import React from 'react'
import { Divider, Space, Switch, Select, Input, DatePicker } from 'antd'
import moment from 'moment'

import { useCacheCampaign, getCampaignsForSelect } from '../../../../hooks/cache/campaign'
import { useCacheTag, getTagsForSelect } from '../../../../hooks/cache/tag'
import { useCacheService, getServicesForSelect, getCategoriesWithOptForSelect } from '../../../../hooks/cache/service'
import { useCacheSpecialization, getSpecializationsForSelect } from '../../../../hooks/cache/specialization'

const dateFormat = 'YYYY-MM-DD'

const yesOrNo = [
  { value: 'YES', label: 'YES' },
  { value: 'NO', label: 'NO' }
]

const Filters = (props) => {
  const { filters } = props

  const { data: campaignsRaw } = useCacheCampaign()
  const { data: tagsRaw } = useCacheTag()
  const { data: servicesRaw } = useCacheService()
  const { data: specializationsRaw } = useCacheSpecialization()

  const isActive = filters ? filters.active == 1 : false
  const statusWorkOnHolidays = filters ? filters.workOnHolidays == 1 : false
  const statusWorkWithMT = filters ? filters.workWithMT == 1 : false
  const readyToWork = filters ? filters.readyToWork == 1 : false
  const priceReview = filters ? filters.priceReview == 1 : false
  const paymentMethodReview = filters ? filters.paymentMethodReview == 1 : false
  const available = filters ? (filters.available ? filters.available : undefined) : undefined
  const campaign = filters ? (filters.campaign ? parseInt(filters.campaign) : undefined) : undefined
  const service = filters ? (filters.service ? parseInt(filters.service) : undefined) : undefined
  const category = filters ? (filters.category ? parseInt(filters.category) : undefined) : undefined
  const tags = filters ? (filters.tags ? filters.tags.map(i => i ? parseInt(i) : 0) : undefined) : undefined
  const specialization = filters
    ? filters.specialization
      ? parseInt(filters.specialization)
      : undefined
    : undefined

  const availableWhen = filters
    ? filters.availableWhen
      ? moment(filters.availableWhen, dateFormat)
      : undefined
    : undefined

  const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

  const campaignList = getCampaignsForSelect(campaignsRaw)
  const tagList = getTagsForSelect(tagsRaw)
  const categoryList = getCategoriesWithOptForSelect(servicesRaw)
  const serviceList = getServicesForSelect(servicesRaw)
  const specializationList = getSpecializationsForSelect(specializationsRaw)

  return (
    <>
      <Space size='small'>
        <Switch
          checked={isActive}
          size='small'
          onChange={(bool) => props.onUpdateFilters({ active: bool ? 1 : 0 })}
        />{' '}
        Actives
        <Divider type='vertical ' />
        <Switch
          checked={statusWorkWithMT}
          size='small'
          onChange={(bool) => props.onUpdateFilters({ workWithMT: bool ? 1 : undefined })}
        />{' '}
        Work with MT
        <Divider type='vertical ' />
        <Switch
          checked={statusWorkOnHolidays}
          size='small'
          onChange={(bool) => props.onUpdateFilters({ workOnHolidays: bool ? 1 : undefined })}
        />{' '}
        Work on Holidays
        <Divider type='vertical ' />
        <Switch
          checked={readyToWork}
          size='small'
          onChange={(bool) => props.onUpdateFilters({ readyToWork: bool ? 1 : undefined })}
        />{' '}
        Ready to Work
        <Divider type='vertical ' />
        <Switch
          checked={priceReview}
          size='small'
          onChange={(bool) => props.onUpdateFilters({ priceReview: bool ? 1 : undefined })}
        />{' '}
        Price Review
        <Divider type='vertical ' />
        <Switch
          checked={paymentMethodReview}
          size='small'
          onChange={(bool) => props.onUpdateFilters({ paymentMethodReview: bool ? 1 : undefined })}
        />{' '}
        Payment Method Review
      </Space>
      <br />
      <br />

      <Space size='small'>
        <Select
          placeholder='Service'
          allowClear
          name='Service'
          size='small'
          showSearch
          options={serviceList}
          filterOption={_filter}
          style={{ minWidth: '150px' }}
          value={service}
          onChange={(e) => {
            props.onUpdateFilters({ service: e ? e : undefined })
          }}
        />
        <Divider type='vertical ' />
        <Select
          placeholder='Category'
          allowClear
          name='Category'
          size='small'
          showSearch
          options={categoryList}
          filterOption={_filter}
          style={{ minWidth: '150px' }}
          value={category}
          onChange={(e) => {
            props.onUpdateFilters({ category: e ? e : undefined })
          }}
        />
        <Divider type='vertical ' />

        <Select
          placeholder='Specialization'
          allowClear
          name='Specialization'
          size='small'
          showSearch
          options={specializationList}
          filterOption={_filter}
          style={{ minWidth: '150px' }}
          value={specialization}
          onChange={(e) => {
            props.onUpdateFilters({ specialization: e ? e : undefined })
          }}
        />

        <Divider type='vertical ' />
        <Select
          placeholder='Campaign'
          allowClear
          name='Campaign'
          size='small'
          showSearch
          options={campaignList}
          filterOption={_filter}
          style={{ minWidth: '150px' }}
          value={campaign}
          onChange={(e) => {
            props.onUpdateFilters({ campaign: e ? e : undefined })
          }}
        />

        <Divider type='vertical ' />

        <Select
          mode='multiple'
          placeholder='Tags'
          allowClear
          size='small'
          showSearch
          options={tagList}
          filterOption={_filter}
          style={{ minWidth: '150px' }}
          value={tags}
          onChange={(e) => {
            props.onUpdateFilters({ tags: e ? e : undefined })
          }}
        />

        <Divider type='vertical ' />
        <Input.Group compact>
          <Select
            placeholder='Available'
            allowClear
            name='Available'
            size='small'
            showSearch
            options={yesOrNo}
            filterOption={_filter}
            style={{ minWidth: '150px' }}
            value={available}
            onChange={(e) => {
              props.onUpdateFilters({ available: e ? e : undefined })
            }}
          />
          {(available === 'YES' || available === 'NO') && (
            <DatePicker
              size='small'
              defaultValue={availableWhen}
              format={dateFormat}
              name='availableWhen'
              onChange={(e) => {
                props.onUpdateFilters({ availableWhen: e ? moment(e).format('YYYY-MM-DD') : null })
              }}
            />
          )}
        </Input.Group>
      </Space>
    </>
  )
}

export default Filters
